import { t } from 'i18next';

import { ErrorResponseErrorItemCodeCompany } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeCompany, string> => ({
  'company:not_found': t('company.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Företaget kunde inte hittas.',
  }),
  'company:user_unauthorized': t('company.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar administratörsrättigheter för företaget.',
  }),
  'company:missing_design_tool_seat': t('company.missingDesignToolSeat', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar rättigheter för Design.',
  }),
  'company:skymap_connect_license_agreement_not_found': t(
    'company.skymapConnectLicenseAgreementNotFound',
    { ns: 'apiErrorCodes', defaultValue: 'Företaget saknar licens för SkyMap Connect.' },
  ),
  'company:user_already_connected_to_design_tool_seat': t(
    'company.userAlreadyConnectedToDesignToolSeat',
    { ns: 'apiErrorCodes', defaultValue: 'Användaren är redan tilldelad en Design-licens.' },
  ),
  'company:project_transfer_request_not_found': t('company.projectTransferRequestNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektöverföringsbegäran hittades inte.',
  }),
  'company:project_transfer_request_already_handled': t(
    'company.projectTransferRequestAlreadyHandled',
    { ns: 'apiErrorCodes', defaultValue: 'Projektöverföringsbegäran har redan hanterats.' },
  ),
});
